import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClear = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.4106 4.41083C14.736 4.08539 15.2635 4.08539 15.589 4.41083C15.9144 4.73626 15.9144 5.26377 15.589 5.58921L5.58897 15.5892C5.26353 15.9146 4.73602 15.9146 4.41058 15.5892C4.08514 15.2638 4.08514 14.7363 4.41058 14.4108L14.4106 4.41083Z",
		fill: "#333333"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.41058 4.41083C4.73602 4.08539 5.26353 4.08539 5.58897 4.41083L15.589 14.4108L15.6459 14.4743C15.9129 14.8016 15.8941 15.2841 15.589 15.5892C15.2839 15.8943 14.8014 15.9131 14.4741 15.6462L14.4106 15.5892L4.41058 5.58921C4.08514 5.26377 4.08514 4.73626 4.41058 4.41083Z",
		fill: "#333333"
	})]
});
export default SvgClear;
